<template>
  <div>
    <div
      v-if="!sourceRows || sourceRows.length === 0"
      class="text-center pa-5 grey--text"
    >
      No sources with goals set
    </div>
    <div v-else class="chart-container">
      <highcharts ref="chart" :options="chartOptions" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    sourceRows: {
      type: Array,
      default: () => []
    }
  },
  mounted() {
    setTimeout(() => {
      if (!this.$refs.chart) return;
      this.$refs.chart.chart.reflow();
    }, 200);
  },
  computed: {
    chartOptions() {
      if (!this.sourceRows || this.sourceRows.length === 0) return {};

      const sorted = [...this.sourceRows].sort(
        (a, b) => (b.goal || 0) - (a.goal || 0)
      );

      const categories = sorted.map(r => r.sourceName);
      const actualData = sorted.map(r => r.retained);
      const goalData = sorted.map(r => r.goal || 0);

      return Object.assign(
        {},
        {
          chart: {
            type: "bar",
            height: Math.max(250, sorted.length * 40 + 80)
          },
          title: { text: "Goal Progress by Source" },
          credits: { enabled: false },
          xAxis: { categories },
          yAxis: { title: { text: "Retained Cases" }, min: 0 },
          legend: { enabled: true },
          plotOptions: {
            bar: {
              dataLabels: { enabled: true }
            }
          },
          series: [
            {
              name: "Actual",
              data: actualData,
              color: "#4CAF50"
            },
            {
              name: "Goal",
              data: goalData,
              color: "#E0E0E0"
            }
          ]
        }
      );
    }
  }
};
</script>

<style scoped>
.chart-container {
  min-height: 270px;
}
</style>
